export default __webpack_public_path__ + "static/sig_compare_comp1_inactive-237984ec82c030ce5a9891c57a5db294.png";